
export * from "./Recognizer";
export * from "./SpeechConnectionFactory";



// WEBPACK FOOTER //
// ../src/sdk/speech.browser/Exports.ts